/** Haptics: one short pulse on hold-to-confirm completion where the device supports it. Never on ordinary taps. */
import { isNativeApp, nativeHaptic } from "./native";

let enabled = true;
export const setHapticsEnabled = (on: boolean): void => { enabled = on; };
export function haptic(kind: "confirm" | "tick" = "confirm"): void {
  if (enabled && isNativeApp()) { nativeHaptic(kind === "confirm" ? 18 : 6); return; }
  if (!enabled || typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
  // Before the first tap Chrome refuses vibrate() and logs an error (#63); stay quiet instead.
  const activation = (navigator as Navigator & { userActivation?: { hasBeenActive: boolean } }).userActivation;
  if (activation && !activation.hasBeenActive) return;
  try { navigator.vibrate(kind === "confirm" ? 18 : 6); } catch { /* unsupported */ }
}
